import { render, staticRenderFns } from "./TextareaValidated.vue?vue&type=template&id=01fc47ac"
import script from "./TextareaValidated.vue?vue&type=script&lang=js"
export * from "./TextareaValidated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports